import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import UIInlineLabel from 'UIComponents/form/UIInlineLabel';
import UIRadioInput from 'UIComponents/input/UIRadioInput';
import UISelect from 'UIComponents/input/UISelect';
import UIToggleGroup from 'UIComponents/input/UIToggleGroup';
import * as AssetSort from '../../../common/constants/AssetSort';
const ASSET_SORT_ORDER = [AssetSort.INSTALL_COUNT_DESC, AssetSort.NEWEST, AssetSort.PRICE_ASC, AssetSort.PRICE_DESC, AssetSort.RANKING_ASC, AssetSort.RATING_EASE_OF_USE_DESC, AssetSort.RATING_SUPPORT_DESC, AssetSort.RATING_VALUE_DESC, AssetSort.RATING_PERFORMANCE_DESC];
export const ASSET_SORT_OPTIONS = ASSET_SORT_ORDER.map(sortValue => ({
  messageKey: `marketplace-assets-ui.themes.sort.${sortValue}`,
  value: sortValue
}));
export function AssetSortToggleGroup({
  onSelect,
  value
}) {
  return /*#__PURE__*/_jsx(UIToggleGroup, {
    name: "sort",
    children: ASSET_SORT_OPTIONS.map(option => /*#__PURE__*/_jsx(UIRadioInput, {
      checked: option.value === value,
      onChange: () => onSelect(option.value),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: option.messageKey
      })
    }, option.value))
  });
}
/* Called during runtime because I18n is not ready when document is loading */

const toSelectOptions = options => options.map(({
  messageKey,
  value
}) => ({
  text: I18n.text(messageKey),
  value
}));

export function AssetSortDropdown({
  className,
  onSelect,
  value
}) {
  return /*#__PURE__*/_jsx(UIInlineLabel, {
    className: classNames(className, 'm-right-0'),
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplace-assets-ui.themes.sort.label"
    }),
    children: /*#__PURE__*/_jsx(UISelect, {
      buttonUse: "transparent",
      menuWidth: 250,
      onChange: event => onSelect(event.target.value),
      options: toSelectOptions(ASSET_SORT_OPTIONS),
      searchable: false,
      value: value
    })
  });
}